module.exports = __webpack_public_path__ + "img/apidays-banner-light.2bd3b114.jpg";